import { stateNameWidget } from './stateNameWidget';
import { actionWidget } from './actionWidget';
import { targetStatesWidget } from './targetStatesWidget';
import { deleteStateButton } from './deleteStateButton';
import { reorderControls } from './reorderControls';
import { getUniqueStateName } from './fsm_utils';


/**
 * returns an state card for the fsm widget
 * @param {Object} props
 * @param {Object} props.library the library object
 * @param {Object} props.application the application object
 * @param {Object} props.sequence the sequence object
 * @param {Object} props.instruction the instruction object
 * @param {Object} props.state current state for the fsm instruction
 * @param {Array} props.states all the states for the fsm instruction
 * @param {() => void} props.onStateChange callback when state is changed
 * @param {() => void} props.onDeleteState callback when state should be deleted
 * @param {() => void} props.onStateMove callback to change position/order of state
 * @param {Boolean} props.isFirstState
 * @param {Boolean} props.isLastState
 * @returns {JQuery<HTMLElement>}
 */
export const stateWidget = (props) => {
  const {
    library,
    application,
    sequence,
    instruction,
    state,
    states,
    onStateChange,
    onDeleteState,
    onStateMove,
    isFirstState,
    isLastState
  } = props;


  const lInnerStateContainer = $('<div>').addClass('ml_fsm_inner_state_container');
  const lStateNames = states.map(pState => pState.stateName);
  const lStateNameWidget = stateNameWidget({
    isInitialState: isFirstState,
    stateName: state.stateName,
    onStateNameChange: (pNewName) => {
      state.stateName = getUniqueStateName(lStateNames, pNewName);
      onStateChange(state);
    },
  });

  const lActionWidget = actionWidget({
    actionSequenceName: state.actionSequenceName,
    application,
    sequence,
    instruction,
    onActionSelect: (pNewAction) => {
      state.actionSequenceName = pNewAction;
      onStateChange(state);
    },
  });

  const lTargetStatesWidget = targetStatesWidget({
    targetStates: state.targetStates,
    states,
    library,
    onAddTargetState: (pNewTargetState) => {
      state.targetStates.push(pNewTargetState);
      onStateChange(state);
    },
    onTargetStatesChange: (pNewTargetStates) => {
      state.targetStates = pNewTargetStates;
      onStateChange(state);
    }
  });


  const lDeleteButton = deleteStateButton({onDeleteState, isHidden: states.length === 1});
  const lReorderControls = reorderControls({onStateMove, isFirstState, isLastState});
  const lAnimatedBackground = $('<div>').addClass('ml_fsm_animated_background');

  const applictionListener = {
    onTrace: (pData) => {
      lAnimatedBackground.removeClass('active');
      lAnimatedBackground.removeClass('paused');
      lAnimatedBackground.removeClass('running');

      const lActiveStates = Object.values(pData.fsmStates);
      const lIsCurrentStateActive = lActiveStates.includes(state.stateName) && pData.state !== 'completed';
      if(lIsCurrentStateActive) { lAnimatedBackground.addClass('active'); }

      const lCurrentSequenceState = pData.sequences[state.actionSequenceName];
      const lIsCurrentStateRunning = typeof lCurrentSequenceState === 'number';

      if(lIsCurrentStateRunning) {
        lAnimatedBackground.addClass('running');
        if(pData.state === 'paused') {
          lAnimatedBackground.addClass('paused');
          lAnimatedBackground.removeClass('running');
        }
      }
    }
  };

  application.addListener(applictionListener);
  lInnerStateContainer.on('remove', () => {
    application.removeListener(applictionListener);
  });

  return $('<div>')
    .addClass('ml_fsm_state_widget')
    .append(
      lReorderControls,
      lInnerStateContainer.append(
        lStateNameWidget,
        lActionWidget,
        lTargetStatesWidget,
        lAnimatedBackground,
      ),
      lDeleteButton
    );
};
